// Hooks / Node modules / Styles
import { Tag } from "elseware-ui";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons

const MAX_REPOLINK_LENGTH = 40;

const SoftwareCardLink = ({ text, link }) => {
  return (
    <div className="flex flex-row items-center gap-2 py-1">
      <div className="font-semibold local-theme-text-xs text-sm">{text}:</div>
      <div className="bg-blue-100 dark:bg-gray-600 py-1 px-3 border dark:border-gray-500 rounded-full text-xs">
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 dark:text-blue-300 hover:underline"
        >
          {link.length > MAX_REPOLINK_LENGTH
            ? `${link.substring(0, MAX_REPOLINK_LENGTH)}...`
            : link}
        </a>
      </div>
    </div>
  );
};

function SoftwareCard({ project }) {
  return (
    <div className="local-theme-bg-md local-theme-border-md border p-4 rounded-lg shadow-md">
      <div className="flex items-center gap-4">
        <div>
          <h2 className="text-xl font-semibold">{project.title}</h2>
          <p className="text-sm local-theme-text-xs flex items-center gap-2 pt-1">
            {project.logo && (
              <img
                src={project.logo}
                alt={project.associatedWith}
                className="h-5 w-5 rounded-full border"
              />
            )}
            Associated with {project.associatedWith}
          </p>
        </div>
      </div>

      <div className="py-2 flex flex-col gap-2">
        {project.links?.length > 0 && project.links.map((link) => {
            return <SoftwareCardLink text={link.text} link={link.link} />
        })}
      </div>

      <p className="local-theme-text-sm mb-2">{project.description}</p>

      <div className="flex flex-wrap mt-4">
        {project.tech.map((tech, i) => (
          <Tag text={tech} key={i} />
        ))}
      </div>
    </div>
  );
}

export default SoftwareCard;
